import { XIcon } from "lucide-react";

interface UiAlertProps {
  showIcon?: boolean;
  children: React.ReactNode;
  className?: string;
  onClose?: () => void;
}

export function UiAlert({
  children,
  onClose,
  showIcon = false,
  className,
}: UiAlertProps) {
  return (
    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded relative ui-alert text-xs my-1">
      {showIcon && (
        <XIcon
          className={`absolute top-2 right-2 cursor-pointer ${className || ""}`}
          width={20}
          height={20}
          onClick={onClose}
        />
      )}
      {children}
    </div>
  );
}
